import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { ThemeBlueprint } from '@backstage/plugin-app-react';
import { UnifiedThemeProvider } from '@backstage/theme';
import { devLightTheme, devTheme } from './devTheme';

/*
 * The two brand themes. Neither is "the default": with no saved preference
 * Backstage picks by `prefers-color-scheme` and only falls back to the first
 * installed theme when no variant matches, so a user's OS decides which of
 * these they land on. Settings > Appearance overrides it from then on.
 *
 * The built-in Backstage themes stay switched off in app-config.yaml — these
 * cover both variants now, and four entries in the picker is two too many.
 */
const devDarkTheme = ThemeBlueprint.make({
  name: 'dev-dark',
  params: {
    theme: {
      id: 'dev-dark',
      title: 'Developing Dark',
      variant: 'dark',
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={devTheme}>{children}</UnifiedThemeProvider>
      ),
    },
  },
});

const devLight = ThemeBlueprint.make({
  name: 'dev-light',
  params: {
    theme: {
      id: 'dev-light',
      title: 'Developing Light',
      variant: 'light',
      Provider: ({ children }) => (
        <UnifiedThemeProvider theme={devLightTheme}>
          {children}
        </UnifiedThemeProvider>
      ),
    },
  },
});

export const themeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [devDarkTheme, devLight],
});
